import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Navigation, { ToggleMenuBtn } from "./Navigation";
import { ButterflyBorder } from "./Template";
import './layout.css'


const Root = ({ }) => {

    const [showDropdown, setShowDropdown] = useState(false)
    const [lastScrollY, setLastScrollY] = useState(0);
    const [showHeader, setShowHeader] = useState(true);
    const [sideNavHidden, setSideNavHidden] = useState(true);
    const [navLayout, setNavLayout] = useState(`${sideNavHidden ? 'hide-sidenav' : 'show-sidenav'}`)

    const controlNavbar = () => {

        if (typeof window !== 'undefined') {
            if (sideNavHidden == true) {
                const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
                // Check if the sum of current scroll position and visible height is approximately equal to the total scrollable height
                // A small tolerance (e.g., 1 pixel) is often used to account for potential rounding differences
                const isAtBottom = (scrollTop + clientHeight >= scrollHeight - 1)
                if (window.scrollY > lastScrollY && window.scrollY > 100) { // Adjust 100 as needed
                    // if scroll down and past a certain threshold, hide the navbar
                    if (sideNavHidden == true) {
                        setShowHeader(false);
                    }
                } else {
                    if (!isAtBottom) {
                        setShowHeader(true);
                    }
                }
            }

            setLastScrollY(window.scrollY);
        }
    };

       useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', controlNavbar);
            // cleanup function to remove the event listener
            return () => {
                window.removeEventListener('scroll', controlNavbar);
            };
        }
    }, [lastScrollY, sideNavHidden]); // Re-run effect only when lastScrollY changes

    useEffect(()=> {
        setNavLayout(`${sideNavHidden ? 'hide-sidenav' : 'show-sidenav'}`)
    }, [sideNavHidden])

    const handleNavToggleClick = () => setSideNavHidden(!sideNavHidden)
 
    function dismissDropdown() {
        console.log('dismissNav called ')
        setShowDropdown(false)
         setSideNavHidden(true)
    }

    function dismissNav() {
        setSideNavHidden(true)
        setShowDropdown(false) 
    }

    return (
        <div id="page-layout-container">
            <header id="page-header" >
                <ButterflyBorder />
                <ToggleMenuBtn handleClick={handleNavToggleClick} showHeader={showHeader} />
                <div id="page-header-content" className={"site-nav " + navLayout}>
                    <img id="header-tnlogo" src="img/timpnatn_banner_logo_watermarked.png" />
                    <Navigation showDropdown={showDropdown} setShowDropdown={setShowDropdown} dismissNav={dismissDropdown} />
                </div>
            </header>
            <main onClick={dismissNav} className="main-layout">
                <Outlet />
            </main>
            <footer id="page-footer">
                <div>
                    <ul className="social-media-icons">
                        <li>
                            <a href="https://www.instagram.com/timpanogostribalnation/" target="_blank" rel="noopener noreferrer">
                                <img className="social-media-icons" src="img/social media icons/insta_icon.png"></img>
                            </a>
                        </li>
                        <li>
                            <a href="https://substack.com/@timpanogostribalnation" target="_blank" rel="noopener noreferrer">
                                <img className="social-media-icons" src="img/social media icons/substack_icon.png"></img>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.patreon.com/cw/TimpanogosTribalNation?utm_source=search&vanity=TimpanogosTribalNation" target="_blank" rel="noopener noreferrer">
                                <img className="social-media-icons" src="img/social media icons/petreon_icon.png"></img>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.facebook.com/Timpanogostribalnation" target="_blank" rel="noopener noreferrer">
                                <img className="social-media-icons" src="img/social media icons/facebook_icon.png"></img>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.youtube.com/@TimpanogosTribalNation" target="_blank" rel="noopener noreferrer">
                                <img className="social-media-icons" src="img/social media icons/youtube_icon.png"></img>
                            </a>
                        </li>
                        <li>
                            <a href="mailto:media.timpanogosnation@proton.me">
                                <img className="social-media-icons" src="img/social media icons/email_icon.png"></img>
                            </a>
                        </li>
                    </ul>
                </div>
                <div>
                    <span id="copyright-msg">&copy; 2026 Timpanogos Nation</span>
                </div>
                <ButterflyBorder />
            </footer>
        </div>
    )
}

export default Root;